import React, { useMemo } from "react";
import { UseFormReturn } from "react-hook-form/dist/types/form";
import { useTranslation } from "react-i18next";
import { FormInput } from "go-form";
import { CustomValidationConfig, CustomValidationConstraint, CustomValidationError } from "go-form/services/types";
import { ApplicationUpdateApi } from "../../../../../../../../../services/Api/Organization/types";

interface Props {
	form: UseFormReturn<ApplicationUpdateApi>;
	setErrors: React.Dispatch<React.SetStateAction<CustomValidationError<ApplicationUpdateApi>[]>>;
}

const HardRockCafeForm = ({ form, setErrors }: Props) => {
	const { t } = useTranslation();
	const {
		register,
		formState: { errors },
	} = form;

	const textInputValidationConfig = useMemo(
		() => ({
			types: [{ constraint: CustomValidationConstraint.REQUIRED }],
			setErrors,
			utils: { watch: form.watch },
		}),
		[setErrors, form.watch]
	) satisfies CustomValidationConfig;

	return (
		<>
			<FormInput
				name="settings.terminal_id"
				errors={errors}
				register={register}
				label={t("modules.app.field.terminal_id.title")}
				customValidationConfig={textInputValidationConfig}
			/>
			<FormInput
				name="settings.location_id"
				errors={errors}
				register={register}
				label={t("modules.app.field.location_id.title")}
				customValidationConfig={textInputValidationConfig}
			/>
			<FormInput
				name="settings.security_guid"
				errors={errors}
				register={register}
				label={t("modules.app.field.security_guid.title")}
				customValidationConfig={textInputValidationConfig}
			/>
		</>
	);
};

export default HardRockCafeForm;
